import { render } from "./list-event.vue?vue&type=template&id=73e52292&scoped=true"
import script from "./list-event.vue?vue&type=script&lang=js"
export * from "./list-event.vue?vue&type=script&lang=js"

import "./list-event.vue?vue&type=style&index=0&id=73e52292&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e52292"]])

export default __exports__